function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as categoryApi from '@/api/categoryApi.js';
import * as selfUtil from '@/utils/ZBKJIutil.js';
import BindCate from './bindCate.vue';
import UploadFile from '@/components/Upload/uploadFile.vue';
export default {
  components: {
    BindCate: BindCate,
    UploadFile: UploadFile
  },
  data: function data() {
    return {
      loading: false,
      constants: this.$constants,
      treeList: [],
      listPram: {}
    };
  },
  mounted: function mounted() {
    this.handlerGetTreeList();
  },
  methods: {
    onchangeIsShow: function onchangeIsShow(row) {
      var _this = this;
      categoryApi.changeJdCateState({
        cateId: row.id,
        status: row.status
      }).then(function () {
        _this.$message.success('修改成功');
        _this.handlerGetTreeList();
      }).catch(function () {
        _this.handlerGetTreeList();
      });
    },
    handlerGetList: function handlerGetList() {
      this.handlerGetTreeList(1);
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this2 = this;
      var isSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.loading = true;
      categoryApi.jdCateLists(_objectSpread({}, this.listPram)).then(function (res) {
        _this2.treeList = _this2.handleAddArrt(res);
        setTimeout(function () {
          _this2.loading = false;
        }, isSearch == 0 ? 1000 : 300);
      }).catch(function () {
        _this2.loading = false;
      });
    },
    handleAddArrt: function handleAddArrt(treeData) {
      var _result = selfUtil.addTreeListLabel(treeData);
      return _result;
    },
    openBindCate: function openBindCate(row) {
      var _this$$refs$BindCateR;
      (_this$$refs$BindCateR = this.$refs['BindCateRef']) === null || _this$$refs$BindCateR === void 0 ? void 0 : _this$$refs$BindCateR.openInit(row);
    },
    syncCate: function syncCate() {
      var _this3 = this;
      this.$confirm('是否确定同步分类', '提示').then(function (result) {
        categoryApi.syncJdCate(_this3.listPram).then(function (data) {
          _this3.$message.success(data || '操作成功！');
          _this3.handlerGetListData(_this3.listPram);
        });
      });
    },
    requestUpload: function requestUpload() {},
    beforeUpload: function beforeUpload(file) {
      var _this4 = this;
      var formData = new FormData();
      formData.append('file', file);
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      categoryApi.importCate(formData).then(function (res) {
        _this4.$message.success('导入成功');
        _this4.handlerGetListData(_this4.listPram);
        loading.close();
      }).catch(function (err) {
        loading.close();
        _this4.$message.error(err.message);
      });
    }
  }
};